/** List of all file types available to be sent to whatapp. */
const whatsAppAllowedMediaList = [
  'jpg',
  'jpeg',
  'png',
  'aac',
  'm4a',
  'amr',
  'mp3',
  'ogg',
  'mp4',
  '3gpp',
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
];

/**
 * Method checks if the provided type is acceptable by whatsapp.
 *
 * @param String type File extension to be checked.
 */
function checkAcceptableFileType(type) {
  // TODO https://app.clickup.com/t/294p4e1
  return true;

  // let pass = false;
  // if (whatsAppAllowedMediaList.includes(type.toLowerCase())) {
  //   pass = true;
  // }
  // return pass;
}

export { whatsAppAllowedMediaList, checkAcceptableFileType };
